import { render, staticRenderFns } from "./FinancesMiniTable.vue?vue&type=template&id=28fb2516&scoped=true&"
import script from "./FinancesMiniTable.vue?vue&type=script&lang=js&"
export * from "./FinancesMiniTable.vue?vue&type=script&lang=js&"
import style0 from "./FinancesMiniTable.vue?vue&type=style&index=0&id=28fb2516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fb2516",
  null
  
)

export default component.exports